import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { cooperation } from '@/mocks/invest';

export default function Cooperation() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="合作方式"
            title="四种合作路径，共建乡村数字商业"
            subtitle="欢迎投资人、产业合作伙伴、县域商业从业者与政策相关部门，以多种方式加入九畴云铺共建。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
          {cooperation.map((c, i) => (
            <Reveal key={c.title} delay={i * 80}>
              <div className="h-full p-6 rounded-lg bg-background-50 border border-background-200 hover:border-accent-300 transition-colors">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-lg bg-accent-100 flex items-center justify-center">
                    <i className={`${c.icon} text-accent-600 text-2xl`}></i>
                  </div>
                  <h3 className="font-heading font-bold text-lg text-foreground-950">{c.title}</h3>
                </div>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{c.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}